import Styles from "css/login_css/loading.module.css";

export default function OnlyLoadingPage() {
    return (
        <div
            style={{
                flex: "1",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div
                style={{
                    width: "40px",
                    height: "40px",
                    border: "4px solid #e0e0e0",
                    borderTop: "4px solid #3498db",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                }}
            />

            <style>
                {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
            </style>
        </div>
    );
}
